/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ baseText: NonNullable<unknown>, seconds: NonNullable<unknown> }} Retry_Countdown_MessageInputs */

const en_retry_countdown_message = /** @type {(inputs: Retry_Countdown_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseText} in ${i?.seconds}`)
};

const id_retry_countdown_message = /** @type {(inputs: Retry_Countdown_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseText} dalam ${i?.seconds}`)
};

const ms_retry_countdown_message = /** @type {(inputs: Retry_Countdown_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseText} dalam ${i?.seconds}`)
};

const ca_retry_countdown_message = /** @type {(inputs: Retry_Countdown_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseText} en ${i?.seconds}`)
};

const cs_retry_countdown_message = /** @type {(inputs: Retry_Countdown_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseText} za ${i?.seconds}`)
};

const da_retry_countdown_message = /** @type {(inputs: Retry_Countdown_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseText} i ${i?.seconds}`)
};

const de_retry_countdown_message = /** @type {(inputs: Retry_Countdown_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseText} in ${i?.seconds}`)
};

const et_retry_countdown_message = /** @type {(inputs: Retry_Countdown_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseText} ${i?.seconds} sekundi pärast`)
};

const es_retry_countdown_message = /** @type {(inputs: Retry_Countdown_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseText} en ${i?.seconds}`)
};

const fr_retry_countdown_message = /** @type {(inputs: Retry_Countdown_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseText} dans ${i?.seconds}`)
};

const hr_retry_countdown_message = /** @type {(inputs: Retry_Countdown_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseText} za ${i?.seconds}`)
};

const it_retry_countdown_message = /** @type {(inputs: Retry_Countdown_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseText} in ${i?.seconds}`)
};

const lv_retry_countdown_message = /** @type {(inputs: Retry_Countdown_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseText} pēc ${i?.seconds} sekundēm`)
};

const lt_retry_countdown_message = /** @type {(inputs: Retry_Countdown_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseText} po ${i?.seconds} sek.`)
};

const hu_retry_countdown_message = /** @type {(inputs: Retry_Countdown_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseText} a ${i?.seconds} oldalon`)
};

const nl_retry_countdown_message = /** @type {(inputs: Retry_Countdown_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseText} over ${i?.seconds}`)
};

const nb_retry_countdown_message = /** @type {(inputs: Retry_Countdown_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseText} om ${i?.seconds}`)
};

const pl_retry_countdown_message = /** @type {(inputs: Retry_Countdown_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseText} za ${i?.seconds}`)
};

const pt_retry_countdown_message = /** @type {(inputs: Retry_Countdown_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseText} em ${i?.seconds}`)
};

const ro_retry_countdown_message = /** @type {(inputs: Retry_Countdown_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseText} în ${i?.seconds}`)
};

const sk_retry_countdown_message = /** @type {(inputs: Retry_Countdown_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseText} za ${i?.seconds}`)
};

const sl_retry_countdown_message = /** @type {(inputs: Retry_Countdown_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseText} v ${i?.seconds}`)
};

const fi_retry_countdown_message = /** @type {(inputs: Retry_Countdown_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseText} ajassa ${i?.seconds}`)
};

const sv_retry_countdown_message = /** @type {(inputs: Retry_Countdown_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseText} om ${i?.seconds}`)
};

const vi_retry_countdown_message = /** @type {(inputs: Retry_Countdown_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseText} trong ${i?.seconds}`)
};

const tr_retry_countdown_message = /** @type {(inputs: Retry_Countdown_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} içinde ${i?.baseText}`)
};

const el_retry_countdown_message = /** @type {(inputs: Retry_Countdown_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseText} σε ${i?.seconds}`)
};

const bg_retry_countdown_message = /** @type {(inputs: Retry_Countdown_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseText} след ${i?.seconds}`)
};

const ru_retry_countdown_message = /** @type {(inputs: Retry_Countdown_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseText} в ${i?.seconds}`)
};

const sr_retry_countdown_message = /** @type {(inputs: Retry_Countdown_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseText} за ${i?.seconds}`)
};

const uk_retry_countdown_message = /** @type {(inputs: Retry_Countdown_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseText} в ${i?.seconds}`)
};

const ka_retry_countdown_message = /** @type {(inputs: Retry_Countdown_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseText}${i?.seconds}-ში`)
};

const hi_retry_countdown_message = /** @type {(inputs: Retry_Countdown_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseText} ${i?.seconds} में`)
};

const th_retry_countdown_message = /** @type {(inputs: Retry_Countdown_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseText} ใน ${i?.seconds}`)
};

const ko_retry_countdown_message = /** @type {(inputs: Retry_Countdown_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} 후 ${i?.baseText}`)
};

const zh_retry_countdown_message = /** @type {(inputs: Retry_Countdown_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} 后${i?.baseText}`)
};

const zh_tw_retry_countdown_message = /** @type {(inputs: Retry_Countdown_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseText} 在 ${i?.seconds} 內`)
};

const ja_retry_countdown_message = /** @type {(inputs: Retry_Countdown_MessageInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.baseText} を${i?.seconds}で`)
};

/**
* | output |
* | --- |
* | "{baseText} in {seconds}" |
*
* @param {Retry_Countdown_MessageInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const retry_countdown_message = /** @type {((inputs: Retry_Countdown_MessageInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Retry_Countdown_MessageInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_retry_countdown_message(inputs)
	if (locale === "ms") return ms_retry_countdown_message(inputs)
	if (locale === "ca") return ca_retry_countdown_message(inputs)
	if (locale === "cs") return cs_retry_countdown_message(inputs)
	if (locale === "da") return da_retry_countdown_message(inputs)
	if (locale === "de") return de_retry_countdown_message(inputs)
	if (locale === "et") return et_retry_countdown_message(inputs)
	if (locale === "es") return es_retry_countdown_message(inputs)
	if (locale === "fr") return fr_retry_countdown_message(inputs)
	if (locale === "hr") return hr_retry_countdown_message(inputs)
	if (locale === "it") return it_retry_countdown_message(inputs)
	if (locale === "lv") return lv_retry_countdown_message(inputs)
	if (locale === "lt") return lt_retry_countdown_message(inputs)
	if (locale === "hu") return hu_retry_countdown_message(inputs)
	if (locale === "nl") return nl_retry_countdown_message(inputs)
	if (locale === "nb") return nb_retry_countdown_message(inputs)
	if (locale === "pl") return pl_retry_countdown_message(inputs)
	if (locale === "pt") return pt_retry_countdown_message(inputs)
	if (locale === "ro") return ro_retry_countdown_message(inputs)
	if (locale === "sk") return sk_retry_countdown_message(inputs)
	if (locale === "sl") return sl_retry_countdown_message(inputs)
	if (locale === "fi") return fi_retry_countdown_message(inputs)
	if (locale === "sv") return sv_retry_countdown_message(inputs)
	if (locale === "vi") return vi_retry_countdown_message(inputs)
	if (locale === "tr") return tr_retry_countdown_message(inputs)
	if (locale === "el") return el_retry_countdown_message(inputs)
	if (locale === "bg") return bg_retry_countdown_message(inputs)
	if (locale === "ru") return ru_retry_countdown_message(inputs)
	if (locale === "sr") return sr_retry_countdown_message(inputs)
	if (locale === "uk") return uk_retry_countdown_message(inputs)
	if (locale === "ka") return ka_retry_countdown_message(inputs)
	if (locale === "hi") return hi_retry_countdown_message(inputs)
	if (locale === "th") return th_retry_countdown_message(inputs)
	if (locale === "ko") return ko_retry_countdown_message(inputs)
	if (locale === "zh") return zh_retry_countdown_message(inputs)
	if (locale === "zh-tw") return zh_tw_retry_countdown_message(inputs)
	if (locale === "ja") return ja_retry_countdown_message(inputs)
	return en_retry_countdown_message(inputs)
});